export const ENTITLEMENTS = {
  customers: 'customers',
  products: 'products',
  segments: 'segments',
  cohorts: 'cohorts',
  experiment: 'experiment',
  activation: 'activation',
};
